import Component from '../core/Component'
import {EMITS as ROOMS_EMITS} from './Rooms'

export default class RoomsContactForm extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            rooms: null,
            contactForm: null,
            contactFormRoomKey: null
        }

        this.rooms = null
        this.activeRoom = null
    }

    prepare() {
        this.rooms = Component.getFromElement(this.ref.rooms)
        this.rooms?.on(ROOMS_EMITS.SELECTED, this.handleRoomSelect)
    }

    handleRoomSelect = data => {
        const activeIndex = data.index

        //klic, ktery se pouziva v $room['cards']
        const activeRoom = this.options.rooms[activeIndex]
        this.activeRoom = activeRoom

        const index = this.options.roomsUsingContactForm.findIndex(room => room === activeRoom)

        if (~index) {
            this.showForm()
        } else {
            this.hideForm()
        }
    }

    showForm() {
        this.ref.contactForm.style.display = 'block'
        this.ref.contactFormRoomKey.value = this.activeRoom
    }

    hideForm() {
        this.ref.contactForm.style.display = 'none'
    }
}